const EntityConstants = {
  STARTUP: 'startup',
  CORP: 'corporate',
  CATALYST: 'catalyst'
}

export default EntityConstants;